import uiRouter from 'angular-ui-router';
import notAllowedComponent from './notAllowed.component';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

let notAllowedModule = angular.module('features.notAllowed', [
  uiRouter,
])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state(STATES.NOT_ALLOWED, {
        url: ROUTES.NOT_ALLOWED,
        component: 'notAllowed',
      });
  })

  .component('notAllowed', notAllowedComponent)

  .name;

export default notAllowedModule;



// WEBPACK FOOTER //
// ./client/app/features/notAllowed/notAllowed.js